'use strict';
module.exports = require('./TriStateCheckbox.vue');